module.exports = __webpack_public_path__ + "img/extend_3.a7bab5f8.png";